export const visit = (vm, at) => {
at({ "ja": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "\u65B0\u3057\u3044\u30E1\u30C3\u30BB\u30FC\u30B8" } } } });
};